import { mapGetters } from 'vuex'
import { getEnabledSwitchActions } from '@/utils/common/tableActions'
import workflowMixin from '@/mixins/workflow'
import { WORKFLOW_TYPES } from '@/constants/workflow'
import { uuid } from '@/utils/utils'
import i18n from '@/locales'

export default {
  mixins: [workflowMixin],
  computed: {
    ...mapGetters(['userInfo']),
  },
  created () {
    this.singleActions = [
      {
        label: i18n.t('system.text_479'),
        permission: 'users_update',
        action: row => {
          this.createDialog('UserUpdateDialog', {
            data: [row],
            columns: this.columns,
            onManager: this.onManager,
          })
        },
      },
      {
        label: i18n.t('system.text_153'),
        actions: row => {
          return [
            ...getEnabledSwitchActions(this, row, ['users_perform_enable', 'users_perform_disable'], {
              actions: [
                () => {
                  this.onManager('performAction', {
                    id: row.id,
                    managerArgs: {
                      action: 'enable',
                    },
                  })
                },
                () => {
                  this.onManager('performAction', {
                    id: row.id,
                    managerArgs: {
                      action: 'disable',
                    },
                  })
                },
              ],
            }),
            {
              label: i18n.t('compute.text_276'),
              permission: 'users_update',
              action: () => {
                this.createDialog('UserUpdatePasswordDialog', {
                  data: [row],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
              meta: () => {
                const { idps } = row
                if (idps && idps.length > 0) {
                  const [{ idp_driver }] = idps
                  if (idp_driver === 'ldap') {
                    return {
                      validate: false,
                      tooltip: this.$t('common_603'),
                    }
                  }
                }
                if (!row.is_local) return { validate: false }
                return {
                  validate: true,
                }
              },
            },
            {
              label: i18n.t('common_493'),
              action: () => {
                this.handleOpenSidepage(row, 'projects')
              },
            },
            {
              label: `${i18n.t('common.reset')} MFA`,
              action: () => {
                this.createDialog('ResetMFADialog', {
                  data: [row],
                  columns: this.columns,
                  onManager: this.onManager,
                })
              },
            },
            {
              label: i18n.t('system.text_129'),
              permission: 'users_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  vm: this,
                  data: [row],
                  columns: this.columns,
                  title: i18n.t('system.text_480'),
                  name: this.$t('dictionary.user'),
                  onManager: this.onManager,
                  workflow: this.buildUserDeleteWorkflow([row]),
                  alert: {
                    message: i18n.t('system.text_513'),
                    type: 'error',
                  },
                  showConfirm: row.is_system_account,
                  confirmText: this.$t('iam.system_user_delete', [row.name]),
                  refresh: this.refresh,
                })
              },
              meta: () => this.$getDeleteResult(row),
            },
          ]
        },
      },
    ]
  },
  methods: {
    buildUserDeleteWorkflow (items) {
      const workflowEnabled = this.checkWorkflowEnabled(WORKFLOW_TYPES.EXECUTE_USER_DELETE)
      const userInfo = this.userInfo || {}
      const { displayname, name } = userInfo

      return {
        enabled: workflowEnabled,
        submitText: this.$t('system.text_532'),
        orderSetBuilder: () => {
          const parameters = items.map(item => {
            const projectId = item.project_id || userInfo.projectId || ''
            const domainId = item.domain_id || userInfo.projectDomainId || 'default'
            const projectDomainName = item.project_domain || (domainId === 'default' ? 'Default' : domainId)
            return {
              action: 'delete',
              resource: 'users',
              resource_id: item.id,
              project: projectId || '',
              project_domain: projectDomainName,
              parameter: {},
            }
          })
          return {
            auto_execute: false,
            name: this.$t('iam.user_delete_workflow_name', [displayname || name || '', this.$moment().format('YYYY-MM-DD'), uuid()]),
            parameters,
          }
        },
        variablesBuilder: (orderSetRes) => {
          const firstItem = items[0]
          const projectId = firstItem?.project_id || userInfo.projectId || ''
          const domainId = firstItem?.domain_id || userInfo.projectDomainId || 'default'
          return {
            process_definition_key: WORKFLOW_TYPES.EXECUTE_USER_DELETE,
            initiator: userInfo.id || '',
            ids: orderSetRes.data.id,
            parameter: '{}',
            project: projectId || '',
            project_domain: domainId,
            execute_resource_order_set_type: 'users_delete',
          }
        },
        onSuccess: () => {
          this.refresh && this.refresh()
          this.$router.push('/workflow')
        },
      }
    },
  },
}
